import { render, staticRenderFns } from "./segundaACero.vue?vue&type=template&id=1c24e20b&scoped=true"
import script from "./segundaACero.vue?vue&type=script&lang=js"
export * from "./segundaACero.vue?vue&type=script&lang=js"
import style0 from "./segundaACero.vue?vue&type=style&index=0&id=1c24e20b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c24e20b",
  null
  
)

export default component.exports